import { getBoundaryColourByLevel, getOpacity } from '@/helpers/colour';

const formatter = 'chart';

/**
 * Format the resultData and relevanceData into display data that can be passed into
 * <dp-chart>
 */
export default function formatChart(kpi, result) {
  const displayType = kpi.getDisplayType();
  const displayData = {
    key: 'Data 1',
    values: [],
    type: displayType,
  };

  const { data, meta: { typeY0 } } = result;
  const {
    grouping,
    displayOptions: { displayBoundaries, hideLineMarkers },
  } = kpi;

  const { property } = kpi.measurements[0];

  const displayColours = displayType !== 'line'
    && ((typeY0 === 'percentage' && displayBoundaries === undefined)
      || displayBoundaries === true);

  if (displayType === 'line') {
    displayData.mode = hideLineMarkers ? 'lines' : 'lines+markers';
  }

  const points = data.map(({
    x, y0, level0, relevance, devices,
  }) => ({
    x: kpi.getPropertyValueKey(grouping, x, true),
    y: typeY0 === 'percentage'
      ? y0 / 100
      : kpi.getPropertyValueKey(property, y0),
    colour: level0 && displayColours
      ? getBoundaryColourByLevel(level0, relevance)
      : undefined,
    opacity: typeY0 !== 'percentage' && relevance
      ? getOpacity(relevance, 1)
      : undefined,
    text: devices ? `${devices} devices` : undefined,
  }));

  // Find any enums that haven't already been added
  const { grouping: { enumerations } } = kpi;
  if (enumerations && enumerations.length) {
    const missing = [];
    enumerations.forEach(({ value, label }) => {
      const found = points.find(({ x }) => x === value);
      if (!found) {
        missing.push(label);
      }
    });

    missing.forEach((x) => {
      points.push({
        x,
        y: 0,
        opacity: 1,
      });
    });
  }
  displayData.values = kpi.sortData(points);
  return {
    displayType,
    displayData,
    isPercent: kpi.isPercent(),
    formatter,
  };
}
